<template>
<v-slider
  v-model="year"
  class="align-center"
  thumb-label="always"
  :label="label"
  :min="1890"
  :max="new Date().getFullYear()"
>
  <template v-slot:append>
    <v-text-field
      v-model="year"
      class="mt-0 pt-0"
      type="number"
      style="width: 60px"
    />
  </template>
</v-slider>
</template>

<script>
export default {
  name: "YearField",
  props: {
    value: Number,
    label: String,
  },
  computed: {
    year: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit("input", val)
      },
    },
  },
}
</script>
